import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTransformation = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentcolor",
		fill: "none",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M15 12H8M12 15l2.47-2.47a.749.749 0 0 0 0-1.06L12 9"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentcolor",
		fill: "none",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M22.965 4.683a1.397 1.397 0 0 0 .062-1.104 1.005 1.005 0 0 0-.287-.423.633.633 0 0 0-.406-.156H11.29c-.47 0-.932.152-1.35.443-.417.292-.778.714-1.053 1.233L1.035 19.5a1.397 1.397 0 0 0-.062 1.105c.066.173.165.32.287.421a.633.633 0 0 0 .406.156h11.041a2.35 2.35 0 0 0 1.35-.443c.417-.292.778-.714 1.053-1.233l7.855-14.824h0z"
	}));
});
export default SvgTransformation;
